import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, Fab } from "@mui/material";
import React from "react";

/**
 * FloatingActionButtons component displays a column of floating action buttons
 * that allow users to refresh content and navigate to the top or bottom of the page.
 *
 * @param {Object} props - The component props
 * @param {Function} props.refreshFunction - Function to call when the refresh button is clicked
 * @returns {JSX.Element} A set of floating action buttons for page navigation and refresh
 */
const FloatingActionButtons = ({ refreshFunction }) => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollToBottom = () => {
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        float: "right",
        position: "sticky",
        bottom: "40px",
        paddingRight: "40px",
      }}
    >
      <Fab color="primary" onClick={refreshFunction}>
        <RefreshIcon />
      </Fab>
      <Fab color="primary" onClick={scrollToTop}>
        <KeyboardArrowUpIcon />
      </Fab>
      <Fab color="primary" onClick={scrollToBottom}>
        <KeyboardArrowDownIcon />
      </Fab>
    </Box>
  );
};

export default FloatingActionButtons;
